module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-deepzoom__page-wrapper ksm-flex-column",
    on: {
      "dblclick": _vm.stopDblClick
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noFacimilie),
      expression: "noFacimilie"
    }],
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "ksm-position-absolute"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "max-height": "100%",
      "max-widht": "100%"
    },
    attrs: {
      "src": _vm.noFacimilie
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noFacimilie),
      expression: "!noFacimilie"
    }],
    ref: "toolbarDiv",
    staticClass: "toolbarDiv ksm-disable-select ksm-flex-00auto",
    staticStyle: {
      "position": "relative",
      "height": "40px",
      "width": "280px"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noFacimilie),
      expression: "!noFacimilie"
    }],
    staticClass: "ksm-deepzoom__page ksm-flex-1"
  }, [_c('div', {
    staticClass: "ksm-position-absolute ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-deepzoom__body ksm-flex-1",
    attrs: {
      "id": _vm.containerId
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    ref: "infobox_template",
    staticClass: "ksm-gummi__end-overlay",
    class: _vm.modusOption.key
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "__body ksm-hyphens"
  })]), _vm._v(" "), _c('div', {
    ref: "popup-menu_template",
    staticClass: "ksm-deepzoom__popupmenu-overlay"
  }, [_vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__head ksm-flex"
  }, [_c('div', {
    staticClass: "__title ksm-flex-1 ksm-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "__close-infobox"
  }, [_vm._v("x")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-deepzoom__popupmenu__color-rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-deepzoom__popup-menuitem"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9480d0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeepzoomView.vue
// module id = 1990
// module chunks = 1